// Locally, we do not check this file as the local Typescript server in editors cannot handle the large JSON files.
// On CI, we will remove this full comment block and will still typecheck this file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  LOCALE_KEY,
  type LocaleValue,
  type TranslatedMessages,
} from '@transcend-io/internationalization';

/**
 * Translations of intl messages
 */
export const PRIVACY_CENTER_TRANSLATIONS: {
  [k in LocaleValue]: () => Promise<{
    /** Default */
    default: TranslatedMessages;
  }>;
} = {
  [LOCALE_KEY.En]: () => import('./en.json'),
  [LOCALE_KEY.Ar]: () => import('./ar.json'),
  [LOCALE_KEY.Fr]: () => import('./fr.json'),
  [LOCALE_KEY.De]: () => import('./de.json'),
  [LOCALE_KEY.It]: () => import('./it.json'),
  [LOCALE_KEY.Ja]: () => import('./ja.json'),
  [LOCALE_KEY.Es]: () => import('./es.json'),
  [LOCALE_KEY.Ru]: () => import('./ru.json'),

  [LOCALE_KEY.ArAe]: () => import('./ar-AE.json'),
  [LOCALE_KEY.FrFr]: () => import('./fr-FR.json'),
  [LOCALE_KEY.DeDe]: () => import('./de-DE.json'),
  [LOCALE_KEY.ItIt]: () => import('./it-IT.json'),
  [LOCALE_KEY.AfZz]: () => import('./af-ZA.json'),
  [LOCALE_KEY.BgBg]: () => import('./bg-BG.json'),
  [LOCALE_KEY.ZhCn]: () => import('./zh-CN.json'),
  [LOCALE_KEY.HrHr]: () => import('./hr-HR.json'),
  [LOCALE_KEY.CsCz]: () => import('./cs-CZ.json'),
  [LOCALE_KEY.DaDk]: () => import('./da-DK.json'),
  [LOCALE_KEY.EnGb]: () => import('./en-GB.json'),
  [LOCALE_KEY.EnCa]: () => import('./en-CA.json'),
  [LOCALE_KEY.EnAe]: () => import('./en-AE.json'),
  [LOCALE_KEY.FiFi]: () => import('./fi-FI.json'),
  [LOCALE_KEY.ElGr]: () => import('./el-GR.json'),
  [LOCALE_KEY.HiIn]: () => import('./hi-IN.json'),
  [LOCALE_KEY.HuHu]: () => import('./hu-HU.json'),
  [LOCALE_KEY.IdId]: () => import('./id-ID.json'),
  [LOCALE_KEY.JaJp]: () => import('./ja-JP.json'),
  [LOCALE_KEY.KoKr]: () => import('./ko-KR.json'),
  [LOCALE_KEY.LtLt]: () => import('./lt-LT.json'),
  [LOCALE_KEY.MsMy]: () => import('./ms-MY.json'),
  [LOCALE_KEY.MrIn]: () => import('./mr-IN.json'),
  [LOCALE_KEY.NbNi]: () => import('./nb-NO.json'),
  [LOCALE_KEY.PlPl]: () => import('./pl-PL.json'),
  [LOCALE_KEY.PtBr]: () => import('./pt-BR.json'),
  [LOCALE_KEY.PtPt]: () => import('./pt-PT.json'),
  [LOCALE_KEY.RoRo]: () => import('./ro-RO.json'),
  [LOCALE_KEY.RuRu]: () => import('./ru-RU.json'),
  [LOCALE_KEY.SrLatnRs]: () => import('./sr-Latn-RS.json'),
  [LOCALE_KEY.SvSe]: () => import('./sv-SE.json'),
  [LOCALE_KEY.TaIn]: () => import('./ta-IN.json'),
  [LOCALE_KEY.ThTh]: () => import('./th-TH.json'),
  [LOCALE_KEY.TrTr]: () => import('./tr-TR.json'),
  [LOCALE_KEY.UkUa]: () => import('./uk-UA.json'),
  [LOCALE_KEY.ViVn]: () => import('./vi-VN.json'),
  [LOCALE_KEY.ZuZa]: () => import('./zu-ZA.json'),
  [LOCALE_KEY.EnUs]: () => import('./en-US.json'),
  [LOCALE_KEY.EnAu]: () => import('./en-AU.json'),
  [LOCALE_KEY.FrBe]: () => import('./fr-BE.json'),
  [LOCALE_KEY.FrCa]: () => import('./fr-CA.json'),
  [LOCALE_KEY.EnIe]: () => import('./en-IE.json'),
  [LOCALE_KEY.NlNl]: () => import('./nl-NL.json'),
  [LOCALE_KEY.NlBe]: () => import('./nl-BE.json'),
  [LOCALE_KEY.EsEs]: () => import('./es-ES.json'),
  [LOCALE_KEY.Es419]: () => import('./es-419.json'),
  [LOCALE_KEY.ZhHk]: () => import('./zh-HK.json'),
  [LOCALE_KEY.DeAt]: () => import('./de-AT.json'),
  [LOCALE_KEY.DeCh]: () => import('./de-CH.json'),
  [LOCALE_KEY.ItCh]: () => import('./it-CH.json'),
  [LOCALE_KEY.FrCh]: () => import('./fr-CH.json'),
  [LOCALE_KEY.HeIl]: () => import('./he-IL.json'),
  [LOCALE_KEY.EnNz]: () => import('./en-NZ.json'),
  [LOCALE_KEY.EtEe]: () => import('./et-EE.json'),
  [LOCALE_KEY.IsIs]: () => import('./is-IS.json'),
  [LOCALE_KEY.LvLv]: () => import('./lv-LV.json'),
  [LOCALE_KEY.MtMt]: () => import('./mt-MT.json'),
  [LOCALE_KEY.SkSk]: () => import('./sk-SK.json'),
  [LOCALE_KEY.SlSl]: () => import('./sl-SL.json'),
};
